import {
    prepareListing as prepareListingService,
    publishListing as publishListingService,
    saveDraftListing as saveDraftListingService,
    withdrawListing as withdrawListingService,
    createInventoryLocation as createInventoryLocationService,
    getListingsByInventoryId as getListingsByInventoryIdService,
    getListingsBySeller as getListingsBySellerService,
} from '../../services/marketplaceListing.service';

/**
 * Thin action wrappers. Following the DropshipListingModal pattern
 * (action.js re-exports services with intent-named functions; modal calls
 * them directly without a Redux dispatch unless reducer state is needed).
 */

export const prepareMarketplaceListing = (marketplace, data) => {
    return prepareListingService(marketplace, data);
};

export const publishMarketplaceListing = (marketplace, data) => {
    return publishListingService(marketplace, data);
};

export const saveDraftMarketplaceListing = (marketplace, data) => {
    return saveDraftListingService(marketplace, data);
};

export const withdrawMarketplaceListing = (marketplace, data) => {
    return withdrawListingService(marketplace, data);
};

export const createMarketplaceLocation = (marketplace, data) => {
    return createInventoryLocationService(marketplace, data);
};

export const getInventoryListings = (data) => {
    return getListingsByInventoryIdService(data);
};

export const getSellerListings = (data) => {
    return getListingsBySellerService(data);
};
